import React, { useMemo, useState } from 'react';
import { Box, Paper, Typography, Divider } from '@mui/material';

function SegmentedBar({ stage, error }) {
  const segments = [1, 2, 3, 4, 5];
  return (
    <Box sx={{ display: 'flex', gap: 0.5, mt: 1 }}>
      {segments.map((s) => (
        <Box
          key={s}
          sx={{
            width: 18,
            height: 6,
            borderRadius: 1,
            bgcolor: error
              ? 'error.main'
              : s <= stage
              ? (s === 5 ? 'success.main' : 'primary.main')
              : 'grey.400',
            opacity: s <= stage ? 1 : 0.6,
          }}
        />
      ))}
    </Box>
  );
}

export default function Toast({ title, message, details, stage = 1, error = false, logPrefix, onClose }) {
  const [expanded, setExpanded] = useState(false);
  const chevron = useMemo(() => (expanded ? '▾' : '▸'), [expanded]);

  return (
    <Paper
      elevation={6}
      sx={{
        p: 1.25,
        mb: 1,
        width: 320,
        bgcolor: '#fff',
        borderRadius: 1.5,
        border: '1px solid #eee',
        position: 'relative'
      }}
    >
      {/* Close button */}
      <Box
        role="button"
        aria-label="Close notification"
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: 6,
          right: 6,
          width: 22,
          height: 22,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 14,
          color: 'text.secondary',
          cursor: 'pointer',
          '&:hover': { bgcolor: 'rgba(0,0,0,0.05)' }
        }}
      >
        ×
      </Box>

      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        {title}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {message}
      </Typography>
      <SegmentedBar stage={stage} error={error} />

      {/* Footer with dropdown toggle at bottom-right */}
      <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
        <Box sx={{ flex: 1 }} />
        <Box
          role="button"
          aria-expanded={expanded}
          onClick={() => setExpanded((v) => !v)}
          sx={{ cursor: 'pointer', userSelect: 'none', color: 'text.secondary', fontSize: 12 }}
        >
          Details {chevron}
        </Box>
      </Box>

      {expanded && (
        <Box sx={{ mt: 1 }}>
          <Divider sx={{ mb: 1 }} />
          <Typography variant="caption" color="text.secondary">
            Request:
          </Typography>
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              wordBreak: 'break-all',
              color: 'text.primary',
              mt: 0.25
            }}
          >
            {logPrefix || '-'}
          </Typography>

          {/* Error/details message */}
          {(details || message) && (
            <Box sx={{ mt: 1 }}>
              <Typography variant="caption" color="text.secondary">
                Details:
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  display: 'block',
                  wordBreak: 'break-word',
                  color: 'text.primary',
                  mt: 0.25
                }}
              >
                {details || message}
              </Typography>
            </Box>
          )}
        </Box>
      )}
    </Paper>
  );
}


